import Staffs                                         from "../../../domain/staff/Staffs";
import { ACTION_TYPE, SetStaffsAction, StaffsAction } from "./StaffsAction";

const reduceStaffs = (action: SetStaffsAction): Staffs => {
  return action.staffs;
};

const staffsReducer = (state: Staffs = new Staffs(), action: StaffsAction): Staffs => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_STAFFS:
      return reduceStaffs(action as SetStaffsAction);
  }
};

export default staffsReducer;
